package pages.login

import api.ApiService
import csstype.*
import api.dataclasses.login.LoginRequest
import ics.materialUI.extensions.alignItems
import ics.materialUI.extensions.justifyContent
import ics.utils.promise.launch
import kotlinx.js.jso
import mui.lab.LoadingButton
import mui.material.*
import mui.material.styles.TypographyVariant
import mui.system.sx
import org.w3c.dom.HTMLInputElement
import react.FC
import react.ReactNode
import react.dom.html.ButtonType
import react.dom.html.InputType
import react.dom.html.ReactHTML.img
import react.dom.onChange
import react.router.useParams
import react.useEffectOnce
import react.useState
import theme.Colors
import theme.ImageRefs

val LoginPage = FC<LoginPageProps>("LoginPage") {props ->
    // state hooks
    val (errorMsgState, setErrorMsgState) = useState<String?>(null)
    val (companyNameInputState, setCompanyNameInputState) = useState("")
    val (usernameInputState, setUsernameInputState) = useState("")
    val (passwordInputState, setPasswordInputState) = useState("")
    val (useCompanyNameFieldState, _) = useState(!props.getCompanyFromUrl)
    val (loadingLoginButtonState, setLoadingLoginButtonState) = useState(false)

    // other hooks
    val params = useParams()

    // vars
    val companyNameParam = params.get("companyName")

    // factories
    val loginRequestBodyFactory: () -> LoginRequest = {
        LoginRequest(
            usernameInputState,
            passwordInputState,
            companyNameInputState.uppercase()
        )
    }

    // handlers before request

    // requests
    val handleLoginRequest: () -> Unit = {
        launch {
            val res = ApiService.login(loginRequestBodyFactory())
            if (res.success) {
                props.sessionSetter(res.data)
            } else {
                setErrorMsgState(res.errorMsg ?: "An unexpected error occurred")
            }
        }
    }

    // handlers after request
    useEffectOnce {
        if (useCompanyNameFieldState && companyNameInputState.isEmpty() && companyNameParam != null) {
            setCompanyNameInputState(companyNameParam.uppercase())
        }
    }

    Box {
        sx {
            height = 100.vh
            width = 100.vw
            backgroundColor = Color(Colors.General.grey)
        }
        Grid {
            container = true
            alignItems = "center"
            justifyContent = "center"

            sx {
                height = 100.vh
                width = 100.vw
                alignContent = AlignContent.center
                justifyContent = JustifyContent.center
            }

            Grid {
                item = true

                Card {
                    elevation = 3

                    sx {
                        padding = 10.px
                    }

                    img {
                        alt = "logo"
                        src = ImageRefs.logoRefLightMode

                        style = jso {
                            marginLeft = 20.px
                            marginRight = 20.px
                        }
                    }

                    Typography {
                        variant = TypographyVariant.h5
                        sx {
                            marginLeft = Auto.auto
                            marginRight = Auto.auto
                            textAlign = TextAlign.center
                        }
                        + "Please login"
                    }

                    errorMsgState?.let {
                        Alert {
                            severity = AlertColor.error
                            sx {
                                marginTop = 10.px
                                marginBottom = 10.px
                            }
                            +errorMsgState
                        }
                    }

                    FormControl {
                        fullWidth = true

                        if (useCompanyNameFieldState) {
                            TextField {
                                id = "owner-input"
                                label = ReactNode("Owner")
                                type = InputType.text
                                variant = FormControlVariant.outlined
                                value = companyNameInputState
                                onChange = {
                                    setCompanyNameInputState(it.target.unsafeCast<HTMLInputElement>().value)
                                }

                                sx {
                                    marginTop = 10.px
                                    marginBottom = 10.px
                                }
                            }
                        }

                        TextField {
                            id = "username-input"
                            label = ReactNode("Username")
                            type = InputType.text
                            variant = FormControlVariant.outlined
                            value = usernameInputState
                            onChange = {
                                setUsernameInputState(it.target.unsafeCast<HTMLInputElement>().value)
                            }

                            sx {
                                marginTop = 10.px
                                marginBottom = 10.px
                            }

                        }

                        TextField {
                            id = "password-input"
                            label = ReactNode("Password")
                            type = InputType.password
                            variant = FormControlVariant.outlined
                            value = passwordInputState
                            onChange = {
                                setPasswordInputState(it.target.unsafeCast<HTMLInputElement>().value)
                            }

                            sx {
                                marginTop = 10.px
                                marginBottom = 10.px
                            }
                        }

                        LoadingButton {
                            id = "login-button"
                            variant = ButtonVariant.contained
                            type = ButtonType.submit
                            loading = loadingLoginButtonState
                            onClick = {
//                            setLoadingLoginButtonState(true)
                                handleLoginRequest()
                            }

                            + "Login"
                        }
                    }

                }

            }
        }
    }


}